/**
 * TrustStrip - verified storefront trust signals.
 *
 * Purpose: Slim reassurance band for high-intent shopping pages.
 * Inputs: optional className.
 * Outputs: accessible icon/text list with only source-verified claims.
 * Constraints: no fake badges, no reviews, no invented guarantees.
 */

const TRUST_ITEMS: { label: string; path: string }[] = [
  { label: 'Veteran-owned', path: 'M12 15l-5 3 2-6-5-4h6l2-6 2 6h6l-5 4 2 6z' },
  { label: 'Secure Stripe checkout', path: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' },
  { label: 'Free US shipping >= $50; $4.99 under', path: 'M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 100-4 2 2 0 000 4zM17 19a2 2 0 100-4 2 2 0 000 4z' },
  { label: '30-day defect coverage', path: 'M12 2l7 4v6c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-4zM9 12l2 2 4-5' },
  { label: 'Fulfillment by Printful', path: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.3 7L12 12l8.7-5M12 22V12' },
]

interface TrustStripProps {
  className?: string
}

export function TrustStrip({ className = '' }: TrustStripProps) {
  return (
    <section
      className={[
        'border-y border-white/10 bg-navy/35',
        className,
      ].filter(Boolean).join(' ')}
      aria-label="Store guarantees"
    >
      <ul className="max-w-7xl mx-auto px-4 sm:px-6 py-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2.5 list-none m-0">
        {TRUST_ITEMS.map(({ label, path }) => (
          <li key={label} className="flex items-center gap-2.5 text-sm text-white/75">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-gold-text shrink-0"
              aria-hidden="true"
            >
              <path d={path} />
            </svg>
            <span className="font-medium leading-snug">{label}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
